import { render, staticRenderFns } from "./NewOrder.vue?vue&type=template&id=2b255284&scoped=true"
import script from "./NewOrder.vue?vue&type=script&lang=js"
export * from "./NewOrder.vue?vue&type=script&lang=js"
import style0 from "./NewOrder.vue?vue&type=style&index=0&id=2b255284&prod&lang=scss&scoped=true"
import style1 from "./NewOrder.vue?vue&type=style&index=1&id=2b255284&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b255284",
  null
  
)

export default component.exports